import React from 'react';
import { PostHogProvider as PostHogProviderBase } from 'posthog-js/react';
import { PostHogConfig } from 'posthog-js';

const publicPosthogKey =
  process.env.NODE_ENV === 'production'
    ? 'phc_2bjzYShoWe4sATbtdzD9pMHOQMJbMiAiENi3spet4Zq' // PV CRM
    : 'phc_TmnKc4ZKBSQKfpOZKlZECwjZENd0F6s1txl894ZwBPl'; // PV CRM (Dev)

const options: Partial<PostHogConfig> = {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'always',
};

export const PostHogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // Comment out this condition to test PostHog locally
  if (window.location.hostname !== 'app.perfectvenue.com') {
    return <>{children}</>;
  }

  return (
    <PostHogProviderBase options={options} apiKey={publicPosthogKey}>
      {children}
    </PostHogProviderBase>
  );
};
